import { useMutation } from '@tanstack/react-query';
import FileDownload from 'js-file-download';

import { useToasts } from '../../cdl/Toast/useToasts';
import { downloadVesselList } from '../../common/api/clients/vessel.api';
import { extractFileName } from '../../common/helpers/extractFileName.helper';
import { translate } from '../../common/helpers/translate.helper';

export const useVesselListExportDownload = () => {
    const { addLoadingToast } = useToasts();
    const { mutateAsync: executeVesselListDownload } = useMutation({
        mutationFn: () => downloadVesselList(),
    });

    return async () => {
        return addLoadingToast(
            () =>
                executeVesselListDownload(undefined, {
                    onSuccess: (response) =>
                        FileDownload(
                            response.data,
                            extractFileName(response.headers['content-disposition'] || '', 'Vessels.xlsx')
                        ),
                }),
            translate('vessel.exportAll.downloading'),
            translate('vessel.exportAll.downloadSuccess'),
            translate('vessel.exportAll.downloadError')
        );
    };
};
